import React from "react";
import PacketHeader from "./PacketHeader";
import PacketStatsBlock from "./PacketStatsBlock";
import "./index.scss";
import PacketListing from "./PacketListing";
import UploadTime from "../../../containers/FileUpload/UploadTime";
const PacketsBlock = ({ records, paginations, page, loading, _handlePageChange, label, _handleTogle, toggle, options }) => {
	return (
		<>
			{/* <div className="packets-block card mb45">
			<div className="top-block">
				<UploadTime />
			</div></div> */}

			<div className="packets-block card">

				<div className="top-block">
					<PacketHeader _handleTogle={_handleTogle} toggle={toggle} options={options} />
					<PacketStatsBlock />
				</div>
				<PacketListing records={records} page={page} paginations={paginations} loading={loading} _handlePageChange={_handlePageChange} label={label} />
			</div>
		</>
	);

}
export default PacketsBlock;